import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';

import { Plus, View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Cell } from '../Cell';
import { VBox, HBox } from '../../../../components/Box';
import { BaseCellComp } from '../BaseCellComp';
import { PerformActionButton } from '../PerformActionButton';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { CellButton, CellButtons } from '../CellButton';
import { VehiclePropertyCheckbox } from '../../../Vehicles/components/VehiclePropertyCheckbox';
import { Label } from '../../../Vehicles/components/VehicleCounterLabel';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import env from '../../../../env';
import styles from './WS_Default.module.css';
import { deleteVehicleProperty, setVehicleProperty } from '../../../Vehicles/actions';
import { selectVehicle } from '../../../Vehicles/selectors';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { REQUEST_USER } from '../../../Users/constants';
import { getPropByName } from '../../../../utils/props';

import { KanbanVehicleRemarks } from '../../components/KanbanVehicleRemarks';
import { DEFAULTS_TASK_FIELDS, REQUEST_VEHICLE_PROPERTY_UPDATE, VEHICLE_TASK_FIELDS } from '../../../Vehicles/constants';
import { selectUserId, selectWorks } from '../../../Api/selectors';
import { AppClientId } from '../../../Shared/constants';

const Container = styled.div`
  .form-controlField,
  .form-controlField .decorated,
  .vehicle-property-loadable.comment {
    width: 100%;
  }
  .comment-text {
    padding: 6px;
    margin-bottom: 12px;
    border-bottom: 1px solid #eee;
  }

  .text-input {
    width: 100%;
    resize: none;
  }
`;

//change this for values of counters
const ranges = {
  MediumSeaGreen: [1, 2],
  DarkOrange: [3, 5],
  Crimson: [6, Infinity],
};

const binaryTypes = {
  task_attach_replate: '0',
};

const STATE = {
  approve: false,
  task_attach_replate: '0',
  ...DEFAULTS_TASK_FIELDS,
  ...VEHICLE_TASK_FIELDS,
  changed: {},
  buttonClicked: false,
};

const TASK_REMARK_TYPE = 'CHECK_AUTO';

/* eslint-disable react/prefer-stateless-function */
class WS1_8_PreInspectionComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  static COUNTER_PROP_NAME = 'walstreet_check_auto_doorlooptijd_counter';

  get counterValue() {
    return this.vehicle?.[this.constructor.COUNTER_PROP_NAME];
  }

  get vehicle() {
    return this.props.vehicle || this.props.cell.vehicle;
  }

  componentDidMount() {
    this.props.vehicle?.tasksRemarks && this.setState({ tasksRemarks: JSON.parse(this.props.vehicle?.tasksRemarks) });
  }

  get vehicle() {
    return this.props.vehicle || this.props.cell.vehicle;
  }

  onSave() {
    const vehicle = this.props.cell.vehicle;
    const remark = {
      id: Date.now(),
      text: this.state.newRemarkText,
      name: getPropByName(this.props?.loggedUser, 'name'),
      surname: getPropByName(this.props.loggedUser, 'surname'),
      date: this.remarkDate,
    };
    this.setState({ buttonClicked: true });

    const tasksRemarks = Array.isArray(this.state.tasksRemarks) ? [...this.state.tasksRemarks, remark] : [remark];
    console.log('tasksRemarks:', tasksRemarks);

    this.props.setRemark(vehicle.id, JSON.stringify(tasksRemarks), result => {
      if (result) {
        this.reset();
      }
    });
  }

  reset() {
    this.setState({ ...STATE });
  }

  toggleField = name => {
    if (this.state[name] === '1') {
      this.setState({ [name]: '0' });
    } else {
      this.setState({ [name]: '1' });
    }
  };

  setField = (name, value) => {
    this.setState(prevState => ({
      ...prevState,
      changed: { ...prevState.changed, [name]: value },
    }));
  };

  generatePayload() {
    return this.state?.changed ?? {};
  }

  renderPlannable(name) {
    let TASK_REMARK_TYPE = '';
    env.clientId == AppClientId.INDEWAL ? (TASK_REMARK_TYPE = name.replace('task_', '')) : (TASK_REMARK_TYPE = name);

    //use the fetched vehicle in the modal
    return (
      <HBox key={name}>
        <HBox>
          <VehiclePropertyCheckbox
            vehicleId={this.props.cell.vehicle.id}
            propertyName={name}
            changedValue={this.state.changed[name]}
            setField={this.setField.bind(this)}
          />
        </HBox>
        {this.props.workTaskRemarks ? (
          <Loader small />
        ) : (
          <KanbanVehicleRemarks
            readOnly
            taskName={TASK_REMARK_TYPE}
            kanbanBoardLabel={this.props.board?.label}
            vehicleId={this.vehicle?.id}
            loggedUserId={this.props.loggedInUserId}
          />
        )}
      </HBox>
    );
  }

  renderApprove() {
    const vehicle = this.props.cell.vehicle;
    if (!this.state.approve) return null;

    let shownFields = { ...VEHICLE_TASK_FIELDS };

    for (let name in shownFields) {
      if (!!vehicle[name]) {
        shownFields[name] = vehicle[name];
      }
    }

    this.setState({ ...shownFields });

    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.props.action.label}>
        <VehicleHeader vehicle={vehicle} />
        {vehicle?.fix_damages_details && (
          <div style={{ maxWidth: '400px' }}>
            <strong>{this.lbl(`kanban.transport_card.fix_damages_details`)}: </strong>
            <span>{vehicle?.fix_damages_details}</span>
          </div>
        )}

        <VBox>
          <div>&nbsp;</div>
          {_.map(shownFields, (value, name) => this.renderPlannable(name))}
        </VBox>

        <div className="d-flex justify-content-end gap-2 mt-2 mb-2">
          <PerformActionButton
            className={styles.confirmButton}
            payload={this.generatePayload()}
            action={this.props.action}
            target={vehicle}
            onChange={this.reset.bind(this)}
          />
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  render() {
    //use the vehicle from the 'action' in the small card

    if (this.props.vehicleDetails)
      return (
        <Container>
          <HBox right>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <ButtonComponent
                  style={'ButtonSoftEditFullWidth'}
                  onClick={this.setStateFn({
                    approve: !this.state.approve,
                  })}
                >
                  <Plus />
                </ButtonComponent>
              </>
            )}
          </HBox>
          {this.renderApprove()}
        </Container>
      );

    return (
      <Cell className={styles.cell}>
        <Container>
          <VehicleHeader vehicle={this.vehicle} />
          <Label count={this.vehicle?.walstreet_check_auto_doorlooptijd_counter} ranges={ranges}>
            {this.vehicle?.walstreet_check_auto_doorlooptijd_counter || '0'}
          </Label>
          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <KanbanVehicleRemarks
                    readOnly
                    taskName={TASK_REMARK_TYPE}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.loggedInUserId}
                  />
                )}
                <CellButton
                  onClick={this.setStateFn({
                    approve: !this.state.approve,
                    regplate_code: this.vehicle.regplate_code || '',
                  })}
                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

WS1_8_PreInspectionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      `${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`,
      REQUEST_USER,
      `${REQUEST_VEHICLE_PROPERTY_UPDATE}-tasksRemarks`,
      REQUEST_VEHICLE_PROPERTY_UPDATE,
    ]),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
    loggedInUserId: selectUserId(),
    workTaskRemarks: selectWorks([`${REQUEST_VEHICLE_PROPERTY_UPDATE}-taskRemarks`]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setRemark(id, dto) {
      dispatch(setVehicleProperty(id, 'tasksRemarks', dto));
    },
    setProperty(name, value) {
      dispatch(setVehicleProperty(id, name, value));
    },
    deleteProperty(name) {
      dispatch(deleteVehicleProperty(id, name));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WS1_8_PreInspection = compose(withConnect, withRouter)(WS1_8_PreInspectionComp);
